import { UploadIcon } from 'lucide-react';
import type { InputHTMLAttributes } from 'react';

interface ImageUploadButtonProps
	extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'className'> {
	hasPreview?: boolean;
}

/**
 * A styled file-input trigger that looks like a button.
 * The native <input> is visually hidden; clicking the label opens the picker.
 */
const ImageUploadButton = ({ hasPreview = false, ...inputProps }: ImageUploadButtonProps) => (
	<label className="flex items-center gap-2 cursor-pointer px-4 py-2 text-[13px] font-medium rounded-md border border-primary bg-white text-primary hover:bg-primary/5 transition-colors w-fit">
		<UploadIcon className="w-4 h-4 shrink-0" />
		<span>{hasPreview ? 'Change image' : 'Upload image'}</span>
		<input type="file" className="sr-only" {...inputProps} />
	</label>
);

export { ImageUploadButton };
